// Shared sort config for Be Aware > Fraud Players mobile.

export interface FraudPlayersSortOption {
  label: string;
  value: string;
}

// Sort options mapped to the real Fraud Players API keys (mirrors the card metrics).
export const FRAUD_PLAYERS_SORT_OPTIONS: FraudPlayersSortOption[] = [
  { label: "Brand Name", value: "brand_display_name" },
  { label: "Total Income", value: "total_income" },
  { label: "CPA", value: "cpa" },
  { label: "RS", value: "revshare" },
  { label: "QFTD", value: "qftd" },
  { label: "FTD", value: "ftd" },
];

// Keys that sort alphabetically; everything else sorts numerically.
const TEXT_SORT_KEYS = new Set(["brand_display_name"]);

// Default sort (mirrors the trigger label shown in the filter).
export const DEFAULT_FRAUD_PLAYERS_SORT: {
  key: string;
  dir: "asc" | "desc";
} = {
  key: "brand_display_name",
  dir: "desc",
};

const cleanNumber = (value: any): number =>
  parseFloat(String(value ?? "0").replace(/[% ,$]/g, "")) || 0;

// Sort rows by the given key/direction. Text keys sort alphabetically,
// everything else numerically; null/undefined values always sink to the bottom.
export const sortFraudPlayersRows = (
  rows: any[],
  key: string,
  dir: "asc" | "desc",
): any[] => {
  if (!key || !rows?.length) return rows ?? [];
  return [...rows].sort((a, b) => {
    const aRaw = a?.[key];
    const bRaw = b?.[key];
    if (aRaw == null && bRaw == null) return 0;
    if (aRaw == null) return 1;
    if (bRaw == null) return -1;
    if (TEXT_SORT_KEYS.has(key)) {
      return dir === "asc"
        ? String(aRaw).localeCompare(String(bRaw))
        : String(bRaw).localeCompare(String(aRaw));
    }
    const aNum = cleanNumber(aRaw);
    const bNum = cleanNumber(bRaw);
    return dir === "asc" ? aNum - bNum : bNum - aNum;
  });
};
